import * as React from 'react';
import { Dropdown, Form, Image, Spinner } from "react-bootstrap";
import './ChangeBankingDetailsForm.css';

export interface ChangeBankingDetailsFormProps {
    bankingDetails: {
        accountType: string;
        accountNumber: string;
        bankName: string;
        branchCode: string;
    };
    accountTypeList: {text: string, value: string}[];
    bankInfoList: {id?: string, name: string, avs?: boolean, avsRealtime?: boolean, debiCheck?: boolean, debiCheckRealtime?: boolean, branchCode?: string}[];
    emitHandleChange: any;
    disableForm?: boolean;
    bankInfoLoading: boolean;
}

interface State {
    bankName: string;
    branchCode: string;
    accountType: string;
    accountNumber: string;
    accountTypeDropdownState: boolean;
    bankDropdownState: boolean;
}

export class ChangeBankingDetailsForm extends React.Component<ChangeBankingDetailsFormProps, State> {
    constructor(props: ChangeBankingDetailsFormProps) {
        super(props);

        this.state = {
            accountNumber: this.props.bankingDetails?.accountNumber ? this.props.bankingDetails.accountNumber: '',
            accountType: this.props.bankingDetails?.accountType ? this.props.bankingDetails.accountType : '',
            bankName: this.props.bankingDetails?.bankName ? this.props.bankingDetails.bankName : '',
            branchCode: this.props.bankingDetails?.branchCode ? this.props.bankingDetails.branchCode : '',
            accountTypeDropdownState: false,
            bankDropdownState: false,
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handleAccountTypeDropdownToggle = this.handleAccountTypeDropdownToggle.bind(this);
        this.handleBankDropdownToggle = this.handleBankDropdownToggle.bind(this);
    }

    async handleChange(e: any) {
        const value: string = e.target.value;
        const key: string = e.target.name;

        e.persist();
        
        this.props.emitHandleChange({ [key]: value });
    }
    
    async handleDropdownChange(e: any, b: any) {
        const value: string = e;
        const key: string = b.target.name;
        b.persist();

        this.props.emitHandleChange({ [key]: value });
    }

    async handleAccountTypeDropdownToggle(e: any) {
        this.setState({
            accountTypeDropdownState: e
        });
    }

    async handleBankDropdownToggle(e: any) {
        this.setState({
            bankDropdownState: e
        });
    }
    
    public render() {
        return (
            <>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Dropdown id="ChooseItem"
                        onSelect={this.handleDropdownChange}
                        onToggle={this.handleAccountTypeDropdownToggle}>
                        <Dropdown.Toggle id="dropdown-basic" >
                            <>
                                {this.props.bankingDetails.accountType &&
                                    <>
                                        <p className="title mb-1 change-banking-details__label"><b>Account type</b></p>
                                        <div className="choose-item__selected">
                                            <p className="choose-item__text hide-overflow noma">{this.props.bankingDetails.accountType}</p>
                                            <a className="choose-item__arrow">
                                                { !this.state.accountTypeDropdownState && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-inline-icon.png" /> }
                                                { this.state.accountTypeDropdownState === true && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-up-inline-icon.png" /> }
                                            </a>
                                        </div>
                                    </>
                                }
                                {!this.props.bankingDetails.accountType &&
                                    <p>Account Type</p>
                                }
                            </>
                        </Dropdown.Toggle>
                        {!this.props.bankInfoLoading &&
                            <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                                {this.props.accountTypeList?.map((accountType, idx) => {
                                    return <Dropdown.Item name="accountType" eventKey={accountType.text} key={accountType.text} value={accountType.text}>
                                        {accountType.text}
                                        {(idx != this.props.accountTypeList.length - 1) && <hr className="cover-divider" />}
                                    </Dropdown.Item>
                                })}
                            </Dropdown.Menu>
                                ||
                                <Spinner className="d-block mx-auto mb-2" animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                        }
                    </Dropdown>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group>
                        <Form.Label className="change-banking-details__label font-weight-bold">Account no.</Form.Label>
                        <Form.Control disabled={!(this.props.disableForm ?? true)} onChange={this.handleChange} value={this.props.bankingDetails.accountNumber} name="accountNumber" type="text" />
                    </Form.Group>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Dropdown id="ChooseItem"
                        onSelect={this.handleDropdownChange}
                        onToggle={this.handleBankDropdownToggle}>
                        <Dropdown.Toggle id="dropdown-basic" >
                            <>
                                {this.props.bankingDetails.bankName &&
                                    <>
                                        <p className="title mb-1 change-banking-details__label"><b>Bank</b></p>
                                        <div className="choose-item__selected">
                                            <p className="choose-item__text hide-overflow noma">{this.props.bankingDetails.bankName}</p>
                                            <a className="choose-item__arrow">
                                                { !this.state.bankDropdownState && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-inline-icon.png" /> }
                                                { this.state.bankDropdownState === true && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-up-inline-icon.png" /> }
                                            </a>
                                        </div>
                                    </>
                                }
                                {!this.props.bankingDetails.bankName &&
                                    <p>Bank Name</p>
                                }
                            </>
                        </Dropdown.Toggle>
                        {!this.props.bankInfoLoading &&
                            <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                                {this.props.bankInfoList?.map((bankInfo, idx) => {
                                    return <Dropdown.Item name="bankName" eventKey={bankInfo.name} key={bankInfo.name} value={bankInfo.name}>
                                        {bankInfo.name}
                                        {(idx != this.props.bankInfoList.length - 1) && <hr className="cover-divider" />}
                                    </Dropdown.Item>
                                })}
                            </Dropdown.Menu>
                        ||
                            <Spinner className="d-block mx-auto mb-2" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        }
                    </Dropdown>
                </div>
                <div className="col-12 col-md-6 change-banking-details__control">
                    <Form.Group onChange={this.handleChange}>
                        <Form.Label className="change-banking-details__label font-weight-bold">Branch code</Form.Label>
                        <Form.Control disabled={this.props.disableForm} value={this.props.bankingDetails.branchCode} name="branchCode" type="text" />
                    </Form.Group>
                </div>
                { this.props.children }
            </>
        )
    }
}
